import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { useLocation } from "react-router-dom";
import Markdown from 'react-markdown'

const CommonTable = ({ rows }) => {
  const location = useLocation();
  let path = location.pathname.split('/')[1]

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        borderRadius: 0,
        border: "1px solid #e0e0e0",
      }}
    >
      <Table
        sx={{ minWidth: 650 }}
        aria-label="simple table"
      >
        <TableHead>
          <TableRow
            sx={{
              backgroundColor: "#fafafa",
              "& th": {
                fontWeight: 500,
                color: "#1d1d1f",
                fontFamily: "'Poppins', sans-serif",
                fontSize: "0.825rem",
                borderBottom: "1px solid #e0e0e0",
                py: 1.5,
              },
            }}
          >
            <TableCell align="left">No</TableCell>
            <TableCell align="left">Slide Name</TableCell>
            <TableCell align="left">Case Info</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows &&
            rows?.map((row, i) => (
              <TableRow
                key={row?.name}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { backgroundColor: "#fafafa" },
                  transition: "background-color 0.15s ease",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  align="left"
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    color: "#616161",
                    fontSize: "0.825rem",
                    fontWeight: 500,
                  }}
                >
                  {i + 1}
                </TableCell>
                <TableCell align="left">
                  <a
                    href={`/${path}/${row?.name}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: "#1d1d1f",
                      textDecoration: "none",
                      fontWeight: 500,
                      fontFamily: "'Poppins', sans-serif",
                      fontSize: "0.825rem",
                    }}
                    onMouseOver={(e) => e.target.style.color = "#616161"}
                    onMouseOut={(e) => e.target.style.color = "#1d1d1f"}
                  >
                    {row?.name}
                  </a>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    color: "rgb(50, 50, 50)",
                    fontSize: "0.825rem",
                    fontWeight: 400,
                  }}
                >
                  <Markdown>{row?.info?.split("\n")[0]}</Markdown>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CommonTable;
